import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';
import { GetCleanerSlotsDto } from '@/api/requests/DTOS';

export const getAvailableSlots = async (searchData: GetCleanerSlotsDto) => {
  const searchParams = new URLSearchParams(
    Object.fromEntries(
      Object.entries(searchData).map(([key, value]: [string, unknown]) => [
        key,
        `${value}`,
      ]),
    ),
  );
  return await apiClient.get(
    `${ENDPOINTS.CLEANERS}/slots?${searchParams.toString()}`,
  );
};
